import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findByKey',
})
export class FindByKeyPipe implements PipeTransform {
  transform(value: string | string[], key: string, source: any[]): any {
    // If the given value is an array of strings...
    if (Array.isArray(value)) {
      return value.map((item) =>
        // eslint-disable-next-line eqeqeq
        source.find((sourceItem) => sourceItem[key] == item)
      );
    }

    // If the value is a string...
    // eslint-disable-next-line eqeqeq
    return source.find((sourceItem) => sourceItem[key] == value);
  }
}
